const STAGES = {
  browsing: "Exploring options",
  comparing: "Comparing your shortlist",
  narrowing: "Narrowing your picks",
  deciding: "Ready to decide",
  chosen: "You decided",
};

export function getDecisionStageLabel(stage) {
  if (!stage) return null;
  return STAGES[stage] || null;
}
